import { useNavigate } from 'react-router'
import { Button, Grid, Typography } from '@mui/material'

import Search from '../../components/search'
import useDocumentTitle from '../../utils/hooks/useDocumentTitle'
import useSharedStyles from '../../utils/shared.styles'

import useStyles from './index.styles'

const Dashboard = () => {
  const classes = useStyles
  const sharedClasses = useSharedStyles
  const navigate = useNavigate()

  useDocumentTitle('Meshify Central')

  return (
    <Grid container={true} sx={[sharedClasses.centerContent, { marginTop: 6 }]}>
      <Grid size={12} sx={[sharedClasses.centerContentHorizontal, { marginBottom: 3 }]}>
        <Typography
          variant="h4"
          sx={{
            textAlign: 'center',
          }}
        >
          What are you looking for?
        </Typography>
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 8,
        }}
        sx={{
          marginBottom: 4,
        }}
      >
        <Search />
      </Grid>
      <Grid container={true} size={12} sx={sharedClasses.centerContentHorizontal}>
        <Typography variant="overline">Or Browse:</Typography>
      </Grid>
      <Grid container={true} direction="row" sx={sharedClasses.centerContent}>
        <Button sx={classes.navButton} onClick={() => navigate('/accounts')}>
          All Accounts
        </Button>
        <Typography sx={classes.navButtonDivider}>•</Typography>
        <Button sx={classes.navButton} onClick={() => navigate('/bookmarks')}>
          Bookmarked
        </Button>
        <Typography sx={classes.navButtonDivider}>•</Typography>
        <Button sx={classes.navButton} onClick={() => navigate('/newly-added-accounts')}>
          Newly Added
        </Button>
      </Grid>
    </Grid>
  )
}

export default Dashboard
